import { useCallback, useEffect, useState } from 'react'

const useTabActive = () => {
  const [visibilityState, setVisibilityState] = useState<{
    visibility: boolean
    time: number | undefined
  }>({ visibility: false, time: 0 })

  const handleVisibilityChange = useCallback(() => {
    const timestamp = new Date().getTime()
    const isVisible = document.visibilityState === 'visible'
    setVisibilityState(prevState => {
      return { visibility: isVisible, time: !isVisible ? timestamp : prevState?.time }
    })
  }, [])

  const registerEvent = useCallback(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  }, [handleVisibilityChange])

  const unregisterEvent = useCallback(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [handleVisibilityChange])

  useEffect(() => {
    registerEvent()
    handleVisibilityChange()
    return unregisterEvent
  }, [registerEvent, unregisterEvent, handleVisibilityChange])

  return visibilityState
}

export default useTabActive
